import { HealthieAppointmentTypeSelectionStep } from "../../../components/SetupDialog/plan-dialogs/steps";
import type { SetupStepComponentProps } from "../../types";

export const HealthieTemplatesStep = ({ selectedIntegrationNames, onComplete, onSkip }: SetupStepComponentProps) => (
  <HealthieAppointmentTypeSelectionStep
    selectedIntegrationNames={selectedIntegrationNames}
    onImportSuccess={onComplete}
    onSkip={onSkip}
  />
);
